import React, { useState } from 'react';
import IframePlayer from 'src/components/IframePlayer';
import { SpeakerElement } from 'src/components/SpeakersGrid';
import Vimeo from 'src/components/Vimeo';
import { urlWebsite } from 'src/config';
import { useConfiguration } from 'src/hooks/Configuration';
import { useLanguage } from 'src/hooks/Language';
import { ContainerClassroom } from './styles';

const ContentClassRoom: React.FC<Record<string, any>> = React.memo(({ courseHook }) => {
    const { configuration } = useConfiguration();
    const { translate, language } = useLanguage();
    const [currentLanguage, setCurrentLanguage] = useState('ptBr');
    const { content, speakers } = courseHook;

    return <ContainerClassroom className='column full-width pad max-1000' style={{ marginTop: '10px' }} >
        <div className='row full-width max-1000 classroom-header' style={{ justifyContent: 'space-between' }}>
            <h2 className='fadeIn' >{content?.[`title_${language}`] ? content?.[`title_${language}`] : content?.title}</h2>

            <div className='row gap-xs' style={{ alignItems: 'center' }}>
                <h2 className='row' onClick={() => setCurrentLanguage('ptBr')} style={{ background: '#fff', borderRadius: '5px', fontSize: '12px', cursor: 'pointer', color: currentLanguage === 'ptBr' ? 'rgb(167, 28, 32)' : '#333', minWidth: '30px', height: '30px', }}>POR</h2>
                {content?.languages?.en ? <h2 className='row' onClick={() => setCurrentLanguage('en')} style={{ background: '#fff', borderRadius: '5px', fontSize: '12px', cursor: 'pointer', color: currentLanguage === 'en' ? 'rgb(167, 28, 32)' : '#333', minWidth: '30px', height: '30px', }}>ENG</h2> : <></>}
                {content?.languages?.es ? <h2 className='row' onClick={() => setCurrentLanguage('es')} style={{ background: '#fff', borderRadius: '5px', fontSize: '12px', cursor: 'pointer', color: currentLanguage === 'es' ? 'rgb(167, 28, 32)' : '#333', minWidth: '30px', height: '30px', }}>ESP</h2> : <></>}

            </div>

        </div>
        <div className='max-1200 fadeIn' style={{ width: '100%' }}>
            {content?.video_type_id === 'vimeo' ? <Vimeo id={currentLanguage === 'ptBr' ? content?.video_id : content?.languages?.[currentLanguage] || content?.video_id} /> : <IframePlayer id={currentLanguage === 'ptBr' ? content?.video_id : content?.languages?.[currentLanguage] || content?.video_id} />}
        </div>

        <p>{content?.description}</p>
        {content?.speakers?.length > 0 ? <>
            <h2 className='fadeIn max-1000' style={{ marginTop: '30px' }}>{translate('Palestrantes')}</h2>

            <div className='row flex-wrap max-1200' style={{ gap: '10px', flexWrap: 'wrap', width: '100%' }}>
                {content?.speakers?.map((speakerID) => {

                    const speaker = speakers?.find(i => i?._id === speakerID);


                    return speaker ? <SpeakerElement speaker={speaker} theme={configuration?.current_event_id_response?.theme} /> : <></>





                })}
            </div>
        </> : <></>}

    </ContainerClassroom>



});

export default ContentClassRoom;